export const QuestionnaireFilters = {
    ADVANCED_OPTIONS: 'advancedOptions',
    QUESTION_TYPE: 'questionType',
} as const;

export const AdvancedOptionFilter = {
    IS_ANSWER_MANDATORY: 'isAnswerMandatory',
    IS_NOT_ANSWER_MANDATORY: 'isNotAnswerMandatory',
} as const;

export type FilterType = (typeof QuestionnaireFilters)[keyof typeof QuestionnaireFilters];
export type AdvancedOptionFilterType =
    (typeof AdvancedOptionFilter)[keyof typeof AdvancedOptionFilter];
